import * as React from 'react';
import { useSelector } from 'react-redux';

import { DealFlexibilitySection } from '../../components/DealFlexibilitySection';
import { useModalWindowWithParams } from '../../utils/useModalWindowWithParams';
import { DealFeaturesModalContainer, IDealFeaturesModalContainerExt } from '../DealFeaturesModalContainer';
import { IDealFeatureCard } from '../../types/promoInfo';
import { trackNavigateToDealForm } from '../../utils/analytics';
import { trackDealFeatureModalShow } from '../DealAnywhereSectionContainer/tracking';
import { selectDealFormUrl } from '../../selectors/promoInfo/selectDealFormUrl';
import { useGetFeatures } from './utils/useGetFeatures';
import { useApplicationContext } from '../../utils/applicationContext';

/**
 * Секция "Гибкий подход к сделкам".
 */
export const DealFlexibilitySectionContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const [featuresModalProps, callFeaturesModal] = useModalWindowWithParams<IDealFeaturesModalContainerExt>();
  const dealFormUrl = useSelector(selectDealFormUrl);
  const { config } = useApplicationContext();
  const isSbrEnabled = config.get<boolean>('e2e-deal-sale.Sbr.Enabled') || /* istanbul ignore next */ false;

  const features = useGetFeatures(isSbrEnabled);

  const onAboutFeatureButtonClick = (card: IDealFeatureCard) => {
    callFeaturesModal(card.modal);
    trackDealFeatureModalShow(card.type);
  };
  const onNavigateToDealFormClick = () => {
    trackNavigateToDealForm('type');
  };

  return (
    <>
      <DealFlexibilitySection
        dealFormUrl={dealFormUrl}
        features={features}
        onAboutFeatureButtonClick={onAboutFeatureButtonClick}
        onNavigateToDealFormClick={onNavigateToDealFormClick}
      />
      <DealFeaturesModalContainer {...featuresModalProps} />
    </>
  );
};
